/**
 * Conversion tracking vocabulary.
 *
 * EVENTS are canonical funnel steps, not vendor event names. The mapping from a
 * step to its GA4, Google Ads and Meta counterparts lives in
 * helpers/analytics/events.js, so components never name a vendor and a step can
 * gain a destination without touching a single call site.
 */

export const EVENTS = {
  PAGE_VIEW: 'PAGE_VIEW',
  SCROLL_DEPTH: 'SCROLL_DEPTH',
  CLICK_BOOK_NOW: 'CLICK_BOOK_NOW',
  CALENDAR_OPENED: 'CALENDAR_OPENED',
  SEARCH_SUBMITTED: 'SEARCH_SUBMITTED',
  DIRECT_SEARCH_SUBMITTED: 'DIRECT_SEARCH_SUBMITTED',
  ROOM_VIEWED: 'ROOM_VIEWED',
  DIRECT_ROOM_EXPANDED: 'DIRECT_ROOM_EXPANDED',
  RATE_SELECTED: 'RATE_SELECTED',
  CHECKOUT_STARTED: 'CHECKOUT_STARTED',
  ADD_ON_ADDED: 'ADD_ON_ADDED',
  DETAILS_SUBMITTED: 'DETAILS_SUBMITTED',
  PURCHASE: 'PURCHASE',
  REFUND: 'REFUND',
  CLICK_EMAIL: 'CLICK_EMAIL',
  CLICK_PHONE: 'CLICK_PHONE',
};

/* Which entrance the guest came through. Stamped on every event as `source`,
   and carried through the shared /book/* checkout on the stay, because both
   entrances converge on the same pages after SELECT_STAY. */
export const FUNNEL_SOURCE_ROOMS = 'rooms';
export const FUNNEL_SOURCE_BOOK_DIRECT = 'book-direct';
/* A stay persisted before this release rehydrates without a source. Reporting
   those as unknown for the 30 minutes redux-persist keeps them is honest;
   guessing an entrance would quietly corrupt the comparison the book-direct
   page exists to be judged on. */
export const FUNNEL_SOURCE_UNKNOWN = 'unknown';

// Every price on this site is in EUR (see FormattedPrice).
export const CURRENCY = 'EUR';

/* Meta events held while consent is undecided. A full funnel fits well inside
   this; past it the earliest steps are the ones worth keeping, so later ones
   are dropped rather than evicting the head of the journey. */
export const MAX_QUEUED_EVENTS = 20;

/* Google events are not queued. With Consent Mode storage denied, gtag writes
   no cookie and no persistent identifier, so a denied-state ping keeps the
   banner's "only with your express prior consent" promise literally while
   preserving the modelling Consent Mode exists for. Replaying held events
   later would also stamp them with wall-clock times minutes from when they
   happened, which corrupts exactly the funnel reports this work is fixing.
   Flip this to route Google through the same buffer as Meta if that reading is
   ever rejected. */
export const QUEUE_GOOGLE_EVENTS = false;
